<ng-container
  *ngIf="{
    isLoadingWithoutData: isLoadingWithoutData$ | async,
    tableData: tableData$ | async,
  } as observables"
>
  <ng-container *ngIf="cartType === 'sample' && (sampleProductsLimit$ | async) === 0">
    <py-notification
      class="mb-2"
      type="info"
      [message]="
        'cart.reachedMaximumAmountOfFreeSamples_text' | cxTranslate: { maxA4SampleProductsPerOrder: maxA4SampleProductsPerOrder }
      "
    ></py-notification>
  </ng-container>
  <ng-container *ngIf="config.selectable; then selectAll"></ng-container>
  <py-responsive-table
    class="mt-4"
    tableClass="d-flex flex-column"
    [entries]="observables.isLoadingWithoutData ? [].constructor(numberOfLoadingEntries || 3) : observables.tableData"
    [rowTemplate]="observables.isLoadingWithoutData ? rowLoading : cartType !== 'sample' ? row : sampleRow"
    [listItemTemplate]="observables.isLoadingWithoutData ? listItemLoading : cartType !== 'sample' ? listItem : sampleRow"
    [omitTbody]="true"
    [breakpoint]="800"
    [key]="'key'"
  >
    <thead>
      <tr class="cx-visually-hidden">
        <th *ngIf="config.selectable">
          <span class="cx-visually-hidden">{{ 'cart.select_heading' | cxTranslate }}</span>
        </th>
        <th>
          <span class="cx-visually-hidden">{{ 'cart.articleImage_heading' | cxTranslate }}</span>
        </th>
        <th>
          <span class="cx-visually-hidden">{{ 'cart.article_heading' | cxTranslate }}</span>
        </th>
        <th>
          <span class="cx-visually-hidden">{{ 'cart.quantityAndUnit_heading' | cxTranslate }}</span>
        </th>
        <th>
          <span class="cx-visually-hidden">{{ 'cart.price_heading' | cxTranslate }}</span>
        </th>
        <th>
          <span class="cx-visually-hidden">{{ 'cart.delete_heading' | cxTranslate }}</span>
        </th>
      </tr>
    </thead>
    <tfoot *ngIf="totalPrice">
      <tr *ngIf="cartType !== 'sample'; else sampleCartTypeFooter" class="d-flex justify-content-between">
        <ng-container *ngIf="textInsteadOfPrice; else pricing">
          <td colspan="9">
            <div class="d-flex flex-column align-items-end">
              <div class="h5">{{ textInsteadOfPrice | cxTranslate }}</div>
              <div>{{ 'cart.numberOfItems_hint' | cxTranslate: { count: observables.tableData?.length || 0 } }}</div>
            </div>
          </td>
        </ng-container>

        <ng-template #pricing>
          <td colspan="2">
            {{ 'cart.numberOfItems_hint' | cxTranslate: { count: observables.tableData?.length || 0 } }}
          </td>
          <ng-container *pyPrincipalConfiguration="'enableDisplayOfPrices'">
            <td colspan="9" class="h5">
              {{ 'cart.totalWithPriceParameter_heading' | cxTranslate: { price: totalPrice | price: 'symbol-narrow' : true } }}
            </td>
          </ng-container>
        </ng-template>
      </tr>
    </tfoot>
    <ng-template #sampleCartTypeFooter>
      <tr class="d-flex justify-content-end">
        <td colspan="9">
          <div class="w-100 d-flex flex-column align-items-end">
            <div class="h5">{{ 'common.freePrice_hint' | cxTranslate }}</div>
            <span>{{ 'cart.numberOfItems_hint' | cxTranslate: { count: observables.tableData?.length || 0 } }}</span>
          </div>
        </td>
      </tr>
    </ng-template>
  </py-responsive-table>
</ng-container>

<ng-template #selectAll>
  <div class="select-all">
    <py-checkbox [showLabel]="true" class="d-flex">
      <input type="checkbox" [checked]="isAllSelected$ | async" (change)="onAllSelect()" />
      <span slot="label">{{ 'cart.selectAll_action' | cxTranslate }}</span>
    </py-checkbox>
  </div>
</ng-template>

<ng-template #row let-entry>
  <tbody
    #orderEntryRows
    py-order-entry-row
    [entry]="asTableData(entry).orderEntry"
    [article]="asTableData(entry).article$ | async"
    [loading]="entry.loading$ | async"
    [selected]="entry.selected$ | async"
    [similarArticles$]="asTableData(entry).similarArticles$"
    [enableEditEntryAndShowingSimilar]="enableEditEntryAndShowingSimilar"
    [isCartWriter]="isCartWriter"
    [formGroup]="formGroup"
    [accountingCodeList$]="accountingCodeList$"
    [accountingCodeListLoading]="accountingCodeListLoading"
    [cartType]="cartType"
    [cartErrors]="cartErrors"
    [showSubstitutesArticles]="!(isOrderCardsUserEnabled$ | async)"
    [showConsignmentStockLevel]="isConsignmentStockLevelVisible"
    [enableSecondaryArticleRowVariant]="enableSecondaryArticleRowVariant$ | async"
    (entrySelect)="onEntrySelect(entry)"
    (updateNote)="onEntryNoteUpdate(entry, $event)"
    (updateStatisticsCode)="onEntryStatisticsCodeUpdate(entry, $event)"
    (updateQuantity)="onEntryQuantityUpdate(entry, $event)"
    (accountingCodeUpdated)="onAccountingCodeUpdated()"
    (delete)="onEntryDelete(entry)"
    (replace)="onEntryReplace(entry, $event)"
    (addToCart)="onEntryAddToCart(entry, $event)"
  ></tbody>
</ng-template>

<ng-template #listItem let-entry>
  <li
    #orderEntryLists
    py-order-entry-list-item
    [entry]="asTableData(entry).orderEntry"
    [article]="asTableData(entry).article$ | async"
    [loading]="entry.loading$ | async"
    [selected]="entry.selected$ | async"
    [similarArticles$]="asTableData(entry).similarArticles$"
    [enableEditEntryAndShowingSimilar]="enableEditEntryAndShowingSimilar"
    [isCartWriter]="isCartWriter"
    [formGroup]="formGroup"
    [accountingCodeList$]="accountingCodeList$"
    [accountingCodeListLoading]="accountingCodeListLoading"
    [cartType]="cartType"
    [cartErrors]="cartErrors"
    [showSubstitutesArticles]="!(isOrderCardsUserEnabled$ | async)"
    [showConsignmentStockLevel]="isConsignmentStockLevelVisible"
    [enableSecondaryArticleRowVariant]="enableSecondaryArticleRowVariant$ | async"
    (entrySelect)="onEntrySelect(entry)"
    (updateNote)="onEntryNoteUpdate(entry, $event)"
    (updateStatisticsCode)="onEntryStatisticsCodeUpdate(entry, $event)"
    (updateQuantity)="onEntryQuantityUpdate(entry, $event)"
    (accountingCodeUpdated)="onAccountingCodeUpdated()"
    (delete)="onEntryDelete(entry)"
    (replace)="onEntryReplace(entry, $event)"
    (addToCart)="onEntryAddToCart(entry, $event)"
  ></li>
</ng-template>

<ng-template #sampleRow let-entry>
  <tbody
    py-sample-order-entry-row
    class="sample-order-entry-row"
    [entry]="asTableData(entry).orderEntry"
    [sampleProductsLimit]="sampleProductsLimit$ | async"
    [sampleProductQuantity]="(sampleProductsLimits$ | async).get(entry.orderEntry?.a4SampleProduct?.code)"
    (delete)="onEntryDelete(entry)"
    (updateQuantity)="onEntryQuantityUpdate(entry, $event)"
  ></tbody>
</ng-template>

<ng-template #rowLoading>
  <tbody py-order-entry-row-loading></tbody>
</ng-template>

<ng-template #listItemLoading>
  <li py-order-entry-list-item-loading></li>
</ng-template>
